

























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Product } from '../../reusable/types'
import LinkComponent from './link.vue'
import { config } from '@/setup/config'

@Component({
  components: {
    LinkComponent,
  },
  i18n: {
    messages: {
      en: {
        back: 'Select a project'
      },
      ru: {
        back: 'Выбор продукта'
      }
    }
  }
})
export default class ProductPage extends Vue {
  @Prop({ required: true }) public readonly product!: Product

  get showBackButton () {
    return config.products.length > 1
  }
}
